import { useCallback } from 'react';
import { PRODUCT_DISCOVERY_PROJECT, type ProjectType } from '@atlassian/jira-common-constants';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties';
import { ONBOARDING_USER_PROPERTY } from '@atlassian/jira-polaris-lib-onboarding/src/controllers/constants';
import type { RemoteState } from '@atlassian/jira-polaris-lib-onboarding/src/controllers/types';
import type { AccountId } from '@atlassian/jira-shared-types';
import { useAccountId } from '@atlassian/jira-tenant-context-controller';

export const useJpdModalCanShow = (projectType?: ProjectType) => {
	const accountId: AccountId | null = useAccountId();

	const checkJpdUserProperties = useCallback(async () => {
		try {
			if (!accountId || projectType !== PRODUCT_DISCOVERY_PROJECT) {
				return false;
			}

			const userProperties = await getUserProperty<RemoteState>(
				'',
				accountId,
				ONBOARDING_USER_PROPERTY,
			);

			return userProperties.videoTutorial.isShown && userProperties.videoTutorial.isClosed;
		} catch (e) {
			return false;
		}
	}, [accountId, projectType]);

	return { checkJpdUserProperties };
};
